/**
 * An on-or-off default one trainer keeps on this device, keyed per trainer because two trainers can
 * share a desk. Anything but the two words (an older build's value, a hand edit, a store that
 * throws) reads as off, which is what a first visit meets.
 */

import type { PreferenceStore } from '~/shared/lib/preferenceStore';

const ON = 'on';
const OFF = 'off';

export function readTrainerFlag(store: PreferenceStore | null, key: string, trainerId: string | null): boolean {
  if (store === null || trainerId === null) return false;
  try {
    return store.getItem(`${key}.${trainerId}`) === ON;
  } catch {
    return false;
  }
}

export function writeTrainerFlag(
  store: PreferenceStore | null,
  key: string,
  trainerId: string | null,
  on: boolean,
): void {
  if (store === null || trainerId === null) return;
  try {
    store.setItem(`${key}.${trainerId}`, on ? ON : OFF);
  } catch {
    // A full or refused store loses the memory of the choice; the choice itself holds this visit.
  }
}
